import { Swiper, Navigation, Scrollbar } from 'swiper';
/* eslint-disable */
import MobileScroll from '../../components/modules/mobile-scroll';
/* eslint-enable */

(function (breakpoints) {
  /**
   * Scrollable elements selector
   * @type {string}
   */
  const scrollableElSelector = '.js-card-collection-scroll';

  /**
   * sliders keeper
   * @type {Array}
   */
  const swipers = [];

  /**
   * Swiper selector
   * @type {string}
   */
  const slider = '.js-card-collection-swiper';

  /**
   * Mobile scroll class keeper
   *
   * @type {MobileScroll}
   */
  const mobileScroll = new MobileScroll({
    selector: scrollableElSelector,
    breakpoint: breakpoints.desktop,
  });

  /**
   * Swiper navigation: scrollbar element selector
   * @type {string}
   */
  const scrollbarNavEl = '.swiper-scrollbar';

  /**
   * slide preloader class
   * @type {string}
   */
  const slidePreloaderClass = 'c-slide-preloader';

  mobileScroll.init();

  function isDesktop() {
    return (window.innerWidth > breakpoints.desktop);
  }

  /**
   * Init slider
   * @return void
   */
  function initSlider(sliderEl) {
    const type = sliderEl.getAttribute('data-type');

    const options = {
      modules: [Navigation, Scrollbar],
      speed: 500,
      slidesPerView: 1.5,
      spaceBetween: 21,
      freeMode: true,
      loop: false,
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        enabled: true,
      },
      lazy: {
        loadPrevNext: true,
        preloaderClass: slidePreloaderClass,
        dragSize: 84,
      },
      keyboard: true,
      navigation: {
        nextEl: sliderEl.nextElementSibling,
        prevEl: sliderEl.previousElementSibling,
      },
      autoHeight: true,
      breakpoints: {
        768: {
          freeMode: false,
          slidesPerView: (type !== 'blog') ? 3 : 2,
          spaceBetween: 40,
          loop: false,
        },
      },
      scrollbar: {
        draggable: true,
        el: sliderEl.querySelector(scrollbarNavEl),
      },
      on: {
        resize() {
          if (!isDesktop()) {
            this.scrollbar.updateSize();
          }
        },
      },
    };

    const swiper = new Swiper(sliderEl, options);

    swiper.init();
    swipers.push(swiper);
  }

  window.addEventListener('load', () => {
    const items = document.querySelectorAll(slider);

    if (items.length) {
      items.forEach((el) => {
        initSlider(el);
      });
    }
  });

  const cardsWithLink = document.querySelectorAll('.card-has-link');

  cardsWithLink.forEach((el) => {
    el.addEventListener('click', (e) => {
      const currentEl = e.target;
      const wrapper = currentEl.closest('.card-has-link');
      const link = wrapper.querySelector('a');

      if (currentEl.matches('.card-subtitle-el,.card-image-el,.card-title-el')) {
        link.click();
      }
    });
  });

  const capacityLinks = document?.querySelectorAll('.card-table__capacity');
  capacityLinks.forEach((elem) => {
    elem.addEventListener('mouseover', () => {
      const propertyID = elem.dataset.property;
      localStorage.setItem('propertyID', propertyID);
    });
  });
// eslint-disable-next-line no-undef
}(breakpoints));
